import { request } from '../request'

export function getCategoryPageList (data) {
    return request({
        url: '/website/category',
        method: 'get',
        data
    })
}

export function getCategoryInfo (id) {
    return request({
        url: '/website/category/' + id,
        method: 'get'
    })
}

export function addCategory (data) {
    return request({
        url: '/website/category',
        method: 'post',
        data
    })
}

export function modifyCategory (data) {
    return request({
        url: '/website/category/' + data.id,
        method: 'put',
        data
    })
}

export function removeCategory (data) {
    return request({
        url: '/website/category/' + data.id,
        method: 'delete',
        data
    })
}

// 职责分工接口

export function getDeptDutyPageList (data) {
    return request({
        url: '/website/deptDuty',
        method: 'get',
        data
    })
}

export function getDeptDuty (id) {
    return request({
        url: '/website/deptDuty/' + id,
        method: 'get'
    })
}

export function addDeptDuty (data) {
    return request({
        url: '/website/deptDuty',
        method: 'post',
        data
    })
}

export function modifyDeptDuty (data) {
    return request({
        url: '/website/deptDuty/' + data.id,
        method: 'put',
        data
    })
}

export function removeDeptDuty (id) {
    return request({
        url: '/website/deptDuty/' + id,
        method: 'delete'
    })
}

// 服务中心接口
export function getServicePageList (data) {
    return request({
        url: '/website/ministerCenter',
        method: 'get',
        data
    })
}

export function addService (data) {
    return request({
        url: '/website/ministerCenter',
        method: 'post',
        data
    })
}

export function modifyService (data) {
    return request({
        url: '/website/ministerCenter/' + data.id,
        method: 'put',
        data
    })
}

export function removeService (id) {
    return request({
        url: '/website/ministerCenter/' + id,
        method: 'delete'
    })
}

// 系统设置

export function getXtszList (data) {
    return request({
        url: '/website/systemConfig',
        method: 'GET',
    })
}

export function saveConfig (data) {
    return request({
        url: '/website/systemConfig',
        method: 'POST',
        data
    })
}

// 信息条目

export function getInfoItemList(data) {
    return request({
        url: '/website/infoItem',
        method: 'get',
        data
    })
}

export function getInfoItem(id) {
    return request({
        url: '/website/infoItem/' + id,
        method: 'get',
    })
}

export function saveInfoItem(data, id) {
    return request({
        url: '/website/infoItem/' + id,
        method: id ? 'put' : 'post',
        data
    })
}

export function removeInfoItem(id) {
    return request({
        url: '/website/infoItem/' + id,
        method: 'delete'
    })
}

// 获取新闻通知列表
export function getMessageList(data) {
    return request({
        url: '/app/getImageNotice',
        method: 'GET',
        data
    })
}

// 获取图片跳转列表
export function getImageList(data) {
    return request({
        url: '/app/imageLink',
        method: 'GET',
        data
    })
}
